<template>
  <input
    v-bind="$attrs"
    type="checkbox"
    :checked="value"
    @change="onChange"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @keyup="$emit('keyup', $event)"
    @keydown="$emit('keydown', $event)"
    @keypress="$emit('keypress', $event)"
  />
</template>

<script>
export default {
  name: 'BaseCheckbox',
  inheritAttrs: false,
  props: {
    value: Boolean
  },
  methods: {
    onChange (event) {
      this.$emit('input', event.target.checked)
      this.$emit('change', event)
    }
  }
}
</script>
